/**
 * @file ChannelResolver.ts
 * @description 按 usageType/usagePage/usage 查找设备通道描述。
 * usagePage/usage 的细节集中在这里，避免 manager、BaseDevice、feature 到处散落匹配逻辑。
 */

import type { ChannelDescriptor } from './Channel'
import type { ChannelSelector } from './ChannelRole'

/**
 * 判断通道描述是否满足选择条件。
 */
export function isChannelMatch(descriptor: ChannelDescriptor, selector: ChannelSelector): boolean {
  if (selector.usageType !== undefined && descriptor.usageType !== selector.usageType) return false
  if (selector.usagePage !== undefined && descriptor.usagePage !== selector.usagePage) return false
  if (selector.usage !== undefined && descriptor.usage !== selector.usage) return false
  return true
}

/**
 * 从通道列表中查找第一个匹配项。
 */
export function resolveChannelDescriptor(
  channels: ChannelDescriptor[],
  selector: ChannelSelector,
): ChannelDescriptor | undefined {
  return channels.find((channel) => isChannelMatch(channel, selector))
}
